import React, { Fragment } from "react";
import PropTypes from "prop-types";
import TextField from "form/components/text-field";
import { includes } from "ramda";
import { getMarket, getStructureFieldInfo, isFromGermany } from "application/functions";
import { telephoneRequiredStoreIds } from "application/constants/app-constants";
import CheckBoxField from "./checkbox-field";


const GermanComponent = (props) => {
  const { register, errors, locale, isSubmitted, structure, handleGermanChecks } = props;

  if (!isFromGermany()) {
    return null;
  }

  return (
    <Fragment>
      <TextField
        register={register}
        errors={errors}
        locale={locale}
        field="street"
        required
        isSubmitted={isSubmitted}
      />
      <TextField
        register={register}
        errors={errors}
        locale={locale}
        field="zip_code"
        required
        isSubmitted={isSubmitted}
      />
      <TextField
        register={register}
        errors={errors}
        locale={locale}
        field="city"
        required
        isSubmitted={isSubmitted}
      />
      <CheckBoxField
        register={register}
        errors={errors}
        locale={locale}
        field="covid_positive"
        label={getStructureFieldInfo(structure, "covid_positive", "label")}
        required
        isSubmitted={isSubmitted}
        handleGermanChecks={(name) => handleGermanChecks(name)}
      />
    </Fragment>
  );
}

GermanComponent.propTypes = {
  register: PropTypes.any,
  errors: PropTypes.any,
  locale: PropTypes.string,
  isSubmitted: PropTypes.bool,
  structrue: PropTypes.object,
  handleGermanChecks: PropTypes.func,
};

export default GermanComponent;